<template>
  <div class="num-products-panel">
    <button class="btn btn-secondary" @click="onDel">
      <i class="fa fa-minus" />
    </button>
    <input
        readonly
        type="text" class="form-control text-center"
        :value="value"
        @input="onChange"
    >
    <button class="btn btn-secondary" @click="onAdd">
      <i class="fa fa-plus" />
    </button>
  </div>
</template>
<script>
export default {
  props: {
    value: { type: Number }
  },
  methods: {
    onChange(e) {
      const value = e.target.value
      this.$emit('input', value)
    },
    onAdd() {
      let value = Number(this.value) + 1
      this.$emit('input', value)
    },
    onDel() {
      let value = Number(this.value) - 1
      if (value > 0) this.$emit('input', value)
    }
  }
}
</script>
<style lang="scss">
.num-products-panel {
  display: flex;
  .btn {
    width: 80px;
  }
  input {
    margin: 0 2rem;
  }
}
</style>